import * as states from '@/assets/common/account-states';

export default (stateId) => {
    if (!isNaN(stateId)) {
        stateId = Object.keys(states).find(key => states[key] === stateId);
    }

    const translations = {
        ACTIVE: `active`,
        DELETED: `deleted`,
    };

    const stateName = translations[stateId];

    if (!stateName) {
        return 'Unknown state';
    }

    return stateName;
};
